import styled from 'styled-components';

import { IconCirclePlus } from '../../../../common/icons/cdl/CirclePlus';
import { theme } from '../../../../common/ui/theme';

interface RotatingIconCirclePlusProps {
    $isRotated: boolean;
}

export const RotatingIconCirclePlus = styled(IconCirclePlus).attrs({
    width: 16,
    height: 16,
})<RotatingIconCirclePlusProps>`
    transform: ${(props) => (props.$isRotated ? 'rotate(45deg)' : 'rotate(0deg)')};
    transition: all 125ms;

    &:hover {
        color: ${(props) => (props.$isRotated ? theme.colors.negative.foreground : theme.colors.foreground.subtle)};
    }
`;
